import * as React from 'react'
import { memo } from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#02542D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2m20 0v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6m20 0-10 7L2 6"
    />
  </svg>
)
const Memo = memo(SvgComponent)
export default Memo
